<button mat-icon-button [matMenuTriggerFor]="menu" data-cy="direct-dial" class="gh-button"><mat-icon>phone</mat-icon></button>

<mat-menu #menu="matMenu" class="gh-menu">
  <mat-card (click)="$event.stopPropagation()">
    <mat-card-header class="tw-items-center">
      <mat-icon mat-card-avatar>dialpad</mat-icon>
      <mat-card-title>Dial Number</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" data-cy="direct-dial-menu" class="gh-dd-form" (ngSubmit)="handleSubmit($event)">
        <formly-form
          class="phone"
          [form]="form"
          [fields]="fields"
          [model]="model"
          [options]="options">
        </formly-form>
        <button class="button" type="submit" data-cy="call-btn" mat-flat-button color="primary" [disabled]="!form.valid || calling || !form?.controls?.phone?.value?.phone">Call</button>
      </form>
    </mat-card-content>
  </mat-card>
</mat-menu>
